import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fuelLevel',
})
export class FuelLevelPipe implements PipeTransform {
  transform(fuelLevel: number | null | undefined): string {
    const fuel = Number(fuelLevel);
    if (!Number.isFinite(fuel)) return 'Sin registro';

    const normalizedFuelLevel = fuel <= 1 ? fuel * 100 : fuel;

    return `${Math.round(normalizedFuelLevel)}%`;
  }
}
